import React from 'react';
import { Star } from 'lucide-react';
const comments = [{
  quote: 'Yo siempre terminaba respondiendo consultas de forma distinta según el día. Tener estructuras claras me bajó muchísimo el desgaste mental.',
  name: 'Valeria P.',
  role: 'Peluquera independiente — Buenos Aires'
}, {
  quote: 'Lo que más me gustó fue que no son cosas lindas para mirar. Son herramientas para usar de verdad.',
  name: 'Marina T.',
  role: 'Dueña de salón — Córdoba'
}, {
  quote: 'Sentís alivio cuando dejás de tener que inventar soluciones para todo.',
  name: 'Romina F.',
  role: 'Estilista profesional — Rosario'
}, {
  quote: 'Yo técnicamente sabía trabajar. Lo que me faltaba era estructura. Ahí estuvo el cambio.',
  name: 'Carla M.',
  role: 'Home Studio'
}, {
  quote: 'Mis clientas empezaron a notar más claridad incluso en cómo explicaba procesos o presupuestos.',
  name: 'Julieta R.',
  role: 'Colorista / estilista'
}, {
  quote: 'El sistema completo me ahorró muchísimo tiempo porque muchas cosas ya estaban listas.',
  name: 'Sofía L.',
  role: 'Peluquera independiente'
}];
export function TestimonialsPreGuarantee() {
  return <section className="bg-[#0B0B12] pt-16 pb-6 px-5 relative overflow-hidden" data-id="element-345">
      <div className="blur-circle bg-brand-gold/5 -bottom-20 -left-20 opacity-20" data-id="element-346" />
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-347">
        <h2 className="text-2xl md:text-3xl font-black text-center text-white mb-4 uppercase tracking-tight" data-id="element-348">
          💬 PROFESIONALES REALES, SITUACIONES REALES
        </h2>
        <p className="text-[10px] text-slate-500 text-center mb-12 font-black uppercase tracking-[0.3em]" data-id="element-349">
          No se trata solo de aprender más. Se trata de trabajar distinto.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-350">
          {comments.map((c, i) => <div key={i} className="bg-white/5 backdrop-blur-md border border-white/10 p-6 rounded-2xl transition-all hover:bg-white/10 hover:border-brand-gold/30 shadow-2xl flex flex-col justify-between" data-id="element-351">
              <div data-id="element-352">
                <div className="flex gap-1 mb-3" data-id="element-353">
                  {[...Array(5)].map((_, j) => <Star key={j} size={12} className="fill-brand-gold text-brand-gold" data-id="element-354" />)}
                </div>
                <p className="text-slate-300 italic text-sm mb-6 leading-relaxed font-medium" data-id="element-355">
                  "{c.quote}"
                </p>
              </div>
              <div className="flex items-center gap-3" data-id="element-356">
                <div className="w-8 h-8 rounded-full bg-brand-gold/10 border border-brand-gold/20 flex items-center justify-center text-brand-gold font-black text-xs" data-id="element-357">
                  {c.name.charAt(0)}
                </div>
                <div data-id="element-358">
                  <p className="font-black text-white text-xs uppercase tracking-tight" data-id="element-359">
                    {c.name}
                  </p>
                  <p className="text-[9px] text-slate-500 font-black uppercase tracking-[0.2em]" data-id="element-360">
                    {c.role}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}